import React from "react"
import styles from "./index.module.scss"

export const ComplaintsContent = () => (
  <div className={styles.container}>
    <h2 style={{ marginBottom: "20px" }}>
      Complaints Procedure  
    </h2>
    <p>
    We strive to provide the highest possible standard of service. However, we acknowledge there may be instances where you feel we have fallen short of this. If this happens, we encourage you to raise a complaint.
    </p>
    <p>
    This Complaints Procedure outlines who can raise a complaint, the process for raising a complaint, the procedure in place to answer your complaint, and the next steps you may take if you remain unsatisfied with our answer.
    </p>
    <h3>
      Who can complain
    </h3>
    <p>
      If we provided a service to you then you may raise a complaint with us or with our regulatory Principal firm, Brooklands Fund Management Limited (“Brooklands”).
    </p>
    <h3>
      Raising a complaint
    </h3>
    <p>
      To ensure your complaint reaches the correct team internally, we encourage you to raise your complaint by emailing Brooklands’ General Counsel and include ‘Complaint’ in your email’s subject line. The contact information for Brooklands’ General Counsel is:
    </p>
    <p>
      Email: info@hoplonpartners.com<br />
      Telephone: +44 (0) 203 7466 930
    </p>
    <h3>
      Answering your complaint
    </h3>
    <p>
      Upon receipt of your complaint, we or Brooklands (depending on who you have contacted) will acknowledge your complaint as soon as reasonably practicable. We will investigate your complaint to provide a fair and reasonable answer. We may request further information from you when this is required to properly assess your case.
    </p>
    <p>
      We aim to provide you with a final written answer to your complaint within 8 weeks after we received your complaint. If we are unable to answer you within 8 weeks’ time, we will contact you to let you know and explain the reasons for this.
    </p>
    <h3>
      If you are not satisfied
    </h3>
    <p>
      If you are not satisfied with our final response, or 8 weeks have passed since you made your complaint, then you may escalate your complaint to the Financial Ombudsman Service. Their contact details are:
    </p>
    <p>
      Financial Ombudsman Service<br />
      Exchange Tower<br />
      Harbour Exchange Square<br />
      London E14 9SR<br />
      0800 023 4567<br />
      https://www.financial-ombudsman.org.uk/
    </p>
   
  </div>
)
